import React, { useState } from 'react';
import data from '../data.json';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const CountriesPage = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const categories = [
    { id: 'all', label: 'All Countries' },
    { id: 'schengen', label: 'Schengen Area' },
    { id: 'eu', label: 'European Union' },
    { id: 'uk', label: 'United Kingdom' },
    { id: 'popular', label: 'Most Popular' }
  ];

  const { europeanCountries } = data;

  const filteredCountries = europeanCountries.filter(country => {
    const matchesCategory = activeCategory === 'all' || country.category.includes(activeCategory);
    const matchesSearch = country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         country.capital.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

 

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-cyan-50">
      {/* Header Section */}
      <section className="pt-24 pb-16 bg-gradient-to-r from-blue-600 to-cyan-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/20 backdrop-blur-sm text-white text-sm font-medium mb-6">
              <span className="w-2 h-2 bg-cyan-300 rounded-full mr-2 animate-pulse"></span>
              EUROPEAN COUNTRIES
            </div>
            <h1 className="text-5xl font-bold mb-6">European Visa Services</h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed">
              Comprehensive visa solutions for 40+ European countries. From student visas to work permits, 
              we guide you through every European immigration pathway.
            </p>
          </div>
        </div>
      </section>

     
      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        
        {/* Search and Filter Section */}
        <div className="mb-12">
          <div className="flex flex-col lg:flex-row gap-6 justify-between items-center mb-8">
            {/* Search Bar */}
            <div className="w-full lg:w-96">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search countries or capitals..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full px-4 py-3 pl-12 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-300"
                />
                <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400">
                  <FontAwesomeIcon icon={faSearch} className='text-blue-500'/>
                </div>
              </div>
            </div>

            {/* Category Filter */}
            <div className="flex flex-wrap gap-2">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setActiveCategory(category.id)}
                  className={`px-4 py-2 rounded-lg font-medium transition-all duration-300 ${
                    activeCategory === category.id
                      ? 'bg-blue-600 text-white shadow-lg'
                      : 'bg-white text-gray-700 hover:bg-blue-50 hover:text-blue-600 border border-gray-200'
                  }`}
                >
                  {category.label}
                </button>
              ))}
            </div>
          </div>

        
        </div>

        {/* Countries Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {filteredCountries.map((country) => (
            <Link to={`/country/${country.id}`} key={country.id}>
            <div key={country.id} className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
              {/* Country Image */}
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={country.image} 
                  alt={country.name}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-full p-2 shadow-lg">
                  <span className="text-2xl">{country.flag}</span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
                  <h3 className="text-xl font-bold text-white">{country.name}</h3>
                  <p className="text-blue-200 text-sm">{country.capital}</p>
                </div>
              </div>

              {/* Country Details */}
              <div className="p-6">
                <p className="text-gray-600 mb-4 text-sm leading-relaxed">{country.description}</p>
                
                {/* Visa Types */}
                <div className="mb-4">
                  <h4 className="font-semibold text-gray-900 mb-2">Available Visas:</h4>
                  <div className="flex flex-wrap gap-2">
                    {country.visaTypes.map((type, index) => (
                      <span 
                        key={index}
                        className="px-2 py-1 bg-blue-50 text-blue-600 rounded-lg text-xs font-medium border border-blue-100"
                      >
                        {type}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            </Link>
          ))}
        </div>

        {/* No Results Message */}
        {filteredCountries.length === 0 && (
          <div className="text-center py-12">
            <div className="text-6xl mb-4">🌍</div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">No countries found</h3>
            <p className="text-gray-600">Try adjusting your search or filter criteria</p>
          </div>
        )}

       

        {/* CTA Section */}
        <div className="text-center">
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200 max-w-2xl mx-auto">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Need Help Choosing a Country?</h2>
            <p className="text-gray-600 mb-6">
              Our experts can help you find the perfect European destination based on your profile and goals
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">

              <Link to='/contact'>

              <button className="bg-blue-600 text-white px-8 py-4 rounded-xl font-semibold hover:bg-blue-700 transition duration-300">
                Book  Consultation
              </button>
            </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountriesPage;
